import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 42,

      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    table: {
      marginTop: 37,
    },
    tableRow: {
      width: 100,
      paddingRight: 0,
      paddingLeft: 15,
      fontSize: 12,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    tableMessage: {
      paddingRight: 38,
      fontSize: 12,
    },
    searchIcon: {
      color: palette.darkGray,
      marginRight: 16,
      opacity: 0.5,
    },
    searchInput: {
      width: '100%',
      color: palette.darkGray,
      '& .MuiOutlinedInput-inputAdornedStart': {
        fontSize: 14,
      },
    },
    centerDate: {
      width: 100,
      fontSize: 12,
    },
    centerTimeAndTime: {
      width: 80,
      fontSize: 12,
    },
  });
